import { Component, TemplateRef, ViewChild, ChangeDetectorRef, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../service/login/login.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable, BehaviorSubject, debounceTime, startWith, switchMap, tap, merge, distinctUntilChanged } from 'rxjs';
import { PlanProtectionService } from '../../service/plan-protection/plan-protection.service';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { PlanProtectionDialogComponent } from '../../dialogs/plan-protection-dialog/plan-protection-dialog.component';
import { NuevoPlanProtectionDialogComponent } from '../../dialogs/nuevo-plan-protection-dialog/nuevo-plan-protection-dialog.component';
import { SpinnerService } from '../../service/spinner-service/spinner.service';
import { VisualizadorPlanProtectionDialogComponent } from '../../../app/dialogs/visualizador-plan-protecion/visualizador-plan-protection-dialog.component';

@Component({
  selector: 'app-servicios-pp',
  templateUrl: './servicios-pp.html',
  styleUrls: ['./servicios-pp.scss']
})

export class ServiciosPPComponent { 

  servicios = [
    {
      nombre: 'Rotaciones',
      disponible: '2',
      total: '2'
    },
    {
      nombre: 'Balanceos',
      disponible: '2',
      total: '2'
    },
    {
      nombre: 'Diagnóstico Mecánico',
      disponible: '2',
      total: '2'
    },
    {
      nombre: 'Nitrógeno',
      disponible: '8',
      total: '8'
    },
    {
      nombre: 'Parchado',
      disponible: '4',
      total: '2'
    }
  ]

  errorsModel = {
    placas: false,
    img_placas: false,
    noSerie: false,
    img_noSerie: false

  }

  base64NoSerie: any
  base64Placas: any
  planProtectionForm: FormGroup

  constructor(private ppService: PlanProtectionService, private fb: FormBuilder, private cdr: ChangeDetectorRef, private spinnerService: SpinnerService){
    
    this.planProtectionForm = this.fb.group({
      placas: [{value: '', disabled: false}, [Validators.required]],
      noSerie: [{value: '', disabled: false}, [Validators.required]]
    })
  }

  
}
